import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
import NormalLayout from '@/components/NormalLayout'

export const constantRouterMap = [
  { path: '/login', component: () => import('@/components/Login'), hidden: true },
  {
    path: '/',
    component: NormalLayout,
    redirect: '/dashboard',
    name: 'Dashboard',
    hidden: true,
    children: [{
      path: 'dashboard',
      component: () => import('@/components/Dashboard')
    }]
  },
  {
    path: '/',
    component: NormalLayout,
    redirect: '/User',
    name: 'User',
    hidden: true,
    children: [{
      path: 'User',
      component: () => import('@/components/Login/UserSet')
    }]

    // path: '/User',
    // component: () => import('@/components/Login/UserSet'),
    // hidden: true,
    // children: [{
    //   path: '/User/userInfo',
    //   component: () => import('@/components/Login/UserInfo'),
    //   name: 'userInfo'
    // }, {
    //   path: '/User/userPassword',
    //   component: () => import('@/components/Login/UserPassword'),
    //   name: 'userPassword'
    // }]
  },
  { // 编辑登记
    path: '/',
    component: NormalLayout,
    redirect: '/editRegistration',
    name: 'EditRegistration',
    hidden: true,
    children: [{
      path: '/editRegistration',
      component: () => import('@/components/Registration/editRegistration')
    }]
  },
  { // 编辑会诊
    path: '/',
    component: NormalLayout,
    redirect: '/editConsultation',
    name: 'EditConsultation',
    hidden: true,
    children: [{
      path: '/editConsultation',
      component: () => import('@/components/Consultation/editConsultation')
    }]
  },
  { // 统计
    path: '/',
    component: NormalLayout,
    redirect: '/Statistics',
    name: 'Statistics',
    hidden: true,
    children: [{
      path: '/Statistics',
      component: () => import('@/components/Statistics/index')
    }]
  },
  {
    path: '/writereport',
    component: () => import('@/components/Diagnostic/writeReport'),
    hidden: true
  },
  {
    path: '/resetpwd',
    component: () => import('@/components/Login/resetpwd'),
    hidden: true
  },
  {
    path: '/Registration/patient',
    component: () => import('@/components/Registration/patient'),
    hidden: true
  },
  {
    path: '/Diagnostic/stateRecord',
    component: () => import('@/components/Diagnostic/stateRecord'),
    hidden: true
  },
  {
    path: '/Diagnostic/historyReport',
    component: () => import('@/components/Diagnostic/historyReport'),
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export const asyncRouterMap = [
  {
    path: '/consultation',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'Consultation',
        component: () => import('@/components/Consultation/'),
        meta: { title: '远程会诊', icon: 'consultation', roles: '远程会诊' }
      }
    ]
  },
  {
    path: '/registration',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'Registration',
        component: () => import('@/components/Registration/'),
        meta: { title: '患者登记', icon: 'registration', roles: '登记' }
      }
    ]
  },
  {
    path: '/screening',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'Screening',
        component: () => import('@/components/Screening'),
        meta: { title: '拍片检查', icon: 'screening', roles: '检查' }
      }
    ]
  },
  {
    path: '/diagnostic',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'diagnostic',
        component: () => import('@/components/Diagnostic'),
        meta: { title: '报告诊断', icon: 'diagnostic', roles: '报告' }
      }
    ]
  },
  {
    path: '/audit',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'Audit',
        component: () => import('@/components/Diagnostic/Audit'),
        meta: { title: '报告审核', icon: 'audit', roles: '审核' }
      }
    ]
  },
  {
    path: '/setting',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'setting',
        component: () => import('@/components/Setting'),
        meta: { title: '系统设置', icon: 'setting', roles: '设置' }
      }
    ]
  },
  {
    path: '/statistics',
    component: NormalLayout,
    children: [
      {
        path: 'index',
        name: 'statistics',
        component: () => import('@/components/Statistics/statistics'),
        meta: { title: '统计', icon: 'nested', roles: '统计' }
      }
    ]
  }
]
